import React from 'react';

import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import { FavoriteAccountCard, GroupedAccountsList, SingleAccountsList } from './components';

import './AccountList.scss';

const AccountListWidget: React.FC = () => {
    const { featureToggles } = useConfig();
    return (
        <Content>
            {featureToggles.enableAccountsDnd ? <GroupedAccountsList /> : <SingleAccountsList />}
            <FavoriteAccountCard />
        </Content>
    );
};

export default AccountListWidget;
